<template>
  <q-dialog
    :model-value="modelValue"
    persistent
    @update:model-value="emit('update:modelValue', $event)"
  >
    <q-card style="width: 500px; max-width: 80vw;">
      <q-card-section>
        <div class="text-h6">Add Building</div>
      </q-card-section>

      <q-card-section>
        <q-form @submit="onSubmit">
          <q-select
            :model-value="formData.brick_class"
            :options="buildingBrickClasses"
            label="BRICK Class"
            filled
            required
            emit-value
            map-options
            class="q-mb-md"
            hint="Select the BRICK ontology class for this building"
            @update:model-value="emit('update:brick-class', $event)"
          />
          <q-input
            :model-value="formData.name"
            label="Building Name"
            filled
            required
            class="q-mb-md"
            @update:model-value="emit('update:name', $event)"
          />
          <q-input
            :model-value="formData.description"
            label="Description"
            filled
            type="textarea"
            rows="3"
            @update:model-value="emit('update:description', $event)"
          />
        </q-form>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn v-close-popup flat label="Cancel" />
        <q-btn
          color="primary"
          label="Add Building"
          :loading="saving"
          @click="onSubmit"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    buildingBrickClasses: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:name',
    'update:brick-class',
    'update:description',
    'submit',
  ]);

  function onSubmit() {
    emit('submit');
  }
</script>
